import { observer } from "mobx-react-lite";
import React, { FC, useMemo, useRef, useState } from "react";
import { langStore } from "@noli/business";
import { loginStore } from "@/modules/login/store";
import styles from "./index.module.scss";
import { getPhoneVCode, postEmailVerification } from "@/pages/Setting/api";
import { SettingLangRecords } from "@/pages/Setting/lang";
import { emailType, phoneType } from "@/utils/reg";
let timer: any;
interface SetPasswordProps {
  label: string;
  type: string;
  placeholder: string;
  value?: string;
  phoneOrEmail?: string;
  onChange: (value: string | number) => void;
}
const SetPassword: FC<SetPasswordProps> = (props) => {
  const lang = langStore.tgt;
  const {
    userState: { userInfo },
  } = loginStore;
  const inputRef = useRef<any>();
  const [time, setTime] = useState(60);
  const { label, type, placeholder, value, phoneOrEmail, onChange } = props;
  // 发送验证码
  const sendCode = async (type: number) => {
    // 1:短信 2：邮件
    try {
      type === 1
        ? await getPhoneVCode({ mobileNumber: phoneOrEmail as string })
        : await postEmailVerification({ email: phoneOrEmail as string, subject: 3 });
      if (timer) {
        clearInterval(timer);
      }
      // 倒计时
      timer = setInterval(() => {
        setTime((time) => {
          if (time === 1) {
            clearInterval(timer);
            return 60;
          }
          return time - 1;
        });
      }, 1000);
    } catch (e) {
      console.error(e);
    }
  };
  const inputNode = useMemo(() => {
    switch (type) {
      case "code":
        return (
          <div
            className={styles.inputContentWrapper}
            onClick={() => {
              inputRef?.current?.focus();
            }}
          >
            <input
              type="number"
              placeholder={placeholder}
              maxLength={6}
              value={value}
              ref={inputRef}
              onChange={(e) => {
                if (e.target.value.length > 6) return;
                onChange(e.target.value);
              }}
            />
            <button
              className={styles.sendCode}
              disabled={!phoneType(phoneOrEmail as string) || time !== 60}
              onClick={async (e) => {
                e.stopPropagation();
                await sendCode(1);
              }}
            >
              {time === 60 ? SettingLangRecords[lang]["Send-code"] : `${time}s`}
            </button>
          </div>
        );
      case "emailCode":
        return (
          <div
            className={styles.inputContentWrapper}
            onClick={() => {
              inputRef?.current?.focus();
            }}
          >
            <input
              type="number"
              placeholder={placeholder}
              maxLength={6}
              value={value}
              ref={inputRef}
              onChange={(e) => {
                if (e.target.value.length > 6) return;
                onChange(e.target.value);
              }}
            />
            <button
              className={styles.sendCode}
              disabled={!emailType(phoneOrEmail as string) || time !== 60}
              onClick={async (e) => {
                e.stopPropagation();
                await sendCode(2);
              }}
            >
              {time === 60 ? SettingLangRecords[lang]["Send-code"] : `${time}s`}
            </button>
          </div>
        );
      case "password":
        return (
          <div
            className={styles.inputContentWrapper}
            onClick={() => {
              inputRef?.current?.focus();
            }}
          >
            <input
              ref={inputRef}
              type="password"
              placeholder={placeholder}
              maxLength={30}
              minLength={6}
              value={value}
              onChange={(e) => {
                if (e.target.value.length > 30) return;
                onChange(e.target.value);
              }}
            />
          </div>
        );
      case "tel":
        return (
          <div
            className={styles.inputContentWrapper}
            onClick={() => {
              inputRef?.current?.focus();
            }}
          >
            <input
              ref={inputRef}
              type="tel"
              placeholder={placeholder}
              value={value}
              onChange={(e) => {
                if (e.target.value.length > 11) return;
                onChange(e.target.value);
              }}
            />
          </div>
        );
      default:
        return (
          <div
            className={styles.inputContentWrapper}
            onClick={() => {
              inputRef?.current?.focus();
            }}
          >
            <input
              ref={inputRef}
              type="text"
              placeholder={placeholder}
              value={value}
              onChange={(e) => {
                onChange(e.target.value);
              }}
            />
          </div>
        );
    }
  }, [type, value, time, phoneOrEmail]);
  return (
    <div className={styles.inputWrapper}>
      <p className={styles.label}>{label}</p>
      {inputNode}
    </div>
  );
};
export default observer(SetPassword);
